import request from "../infra/request";

export const fetchErrorReports = async () => {
  try {
    const response = await request.get("/admin/error-gp-reports");
    return { data: response.data };
  } catch (error) {
    return { error };
  }
};

export const deleteErrorReportById = async ({ id }) => {
  try {
    const response = await request.delete(`/admin/error-gp-reports/raw/${id}`);
    return { data: response.data };
  } catch (error) {
    return { error };
  }
};

export const moveErrorReportById = async ({ id }) => {
  try {
    const response = await request.post(`/admin/error-gp-reports/file/${id}`);
    return { data: response.data };
  } catch (error) {
    return { error };
  }
};

// Link Report on GP Report Upload: merges gp_report.id, appointment_date and name into the
// workflow, as the page did with Firestore. Unlike the calls above it rejects on failure, as
// that write did, and the page leaves the rejection unhandled as before.
export const linkErrorReportToWorkflow = async ({ workflowId, id, appointmentDate, name }) => {
  await request.put(`/admin/error-gp-reports/workflows/${encodeURIComponent(workflowId)}/gp-report`, {
    gpReport: {
      id,
      appointment_date: appointmentDate,
      name,
    },
  });
};
